export default __webpack_public_path__ + "static/media/NeedHelp.dab72d91.jpg";